import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Status, States } from '@sift/resift/models/Status';
import { useSelector, useDispatch } from 'react-redux';
import _get from 'lodash/get';

import { getThemesFetch } from 'store/themes/actions/getThemes';
import { createPreviewTheme } from 'store/themes/actions/createPreviewTheme';
import { destroyAllThemes } from 'store/themes/actions/destroyAllThemes';

import combineStatuses from 'pages/General/tabs/Theming/_helpers/combineStatuses';
import PreviewDialog from './PreviewDialog';

const unknownStatus = new Status(States.UNKNOWN);

function PreviewDialogContainer({ backgroundUrl, logoUrl, open, pictureUrl, settings, ...rest }) {
  const dispatch = useDispatch();
  const themes = useSelector(state => _get(state, 'themes'));
  const themesFetch = getThemesFetch(themes);
  const previewThemeId = _get(themes, 'previewThemeId');
  const status = combineStatuses(themes.status || unknownStatus, themesFetch.status);

  useEffect(() => {
    if (!open) return;

    onPreviewFetchRequested();
  }, [open]);

  const onPreviewFetchRequested = () =>
    dispatch(
      createPreviewTheme({
        settings,
        // `|| null` normalizes the falsy types
        logoUrl: logoUrl || null,
        backgroundUrl: backgroundUrl || null,
        pictureUrl: pictureUrl || null,
      }),
    );

  const onDestroyAllThemes = () => dispatch(destroyAllThemes());

  return (
    <PreviewDialog
      backgroundUrl={backgroundUrl}
      logoUrl={logoUrl}
      open={open}
      pictureUrl={pictureUrl}
      settings={settings}
      status={previewThemeId ? new Status(States.NORMAL) : status}
      themeId={previewThemeId}
      onDestroyAllThemes={onDestroyAllThemes}
      {...rest}
    />
  );
}

PreviewDialogContainer.propTypes = {
  backgroundUrl: PropTypes.string,
  logoUrl: PropTypes.string,
  open: PropTypes.bool.isRequired,
  pictureUrl: PropTypes.string,
  settings: PropTypes.object,
  themeId: PropTypes.string,
};

export default PreviewDialogContainer;
